import {RecordForm} from '../forms/RecordForm';


import {useNotificationSubscription} from '../hooks/useNotificationSubscription.ts';
import {IndexPageNavigation} from "../navigation/IndexPageNavigation";
import {FormPageLayout} from "@flexinet/ui-components";


export const AddPage = () => {

    const {
        record,
        createRecord,
    } = useNotificationSubscription();

    return (
        <FormPageLayout
            title='Add Notification Subscription'
            pageNavigation={<IndexPageNavigation/>}
        >
            <RecordForm record={record} handleSubmit={createRecord}/>
        </FormPageLayout>
    );
};
